// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QMeQ","placeholdersHeader":"styles_placeholdersHeader__3EANd","editorStyle":"styles_editorStyle__hXmiK","placeholdersBox":"styles_placeholdersBox__1o6nu"};